import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import { startTokenExpiryTimer } from '../api/tokenExpiryHelper';
import { useEffect } from 'react';

const App = () => {
  console.log(' ');
  useEffect(() => {
  const token = localStorage.getItem("token");

  if (token) {
    startTokenExpiryTimer();
  }
}, []);
  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
};

export default App;
